<template>
  <div v-if="pageGroupedElements.length">
    <div
      v-for="(page, index) in pageGroupedElements"
      :key="'page-' + index"
      class="position-relative dinA4"
    >
      <img :src="require('@/assets/carga-header.png')" class="mb-0 page__header" />

      <div class="page__container">
        <div
          v-for="(combo, comboIndex) in page"
          :key="'combo-' + comboIndex"
        >
          <div
            v-if="combo[0] && combo[0].type === 'table'"
            class="d-flex justify-center"
            :class="{ 'mt-10': comboIndex > 0 }"
          >
            <PdfProductTable
              v-for="(id, i) in combo[0].ids"
              :key="'table-' + i"
              :ref="`table-${index}-${comboIndex}`"
              :type="combo[0].tableType"
              :tableData="productTableList[id]"
              :tableId="id"
              :image="i === 0 && combo[0].imageUrl"
              :descKey="getProduct(id) ? getProduct(id).desc_key : ''"
            />
          </div>

          <!-- Handle text as combo[1] (original combined layout) -->
          <div
            v-if="combo[1] && combo[1].type === 'text'"
            class="d-flex justify-center mt-5"
          >
            <div :class="combo[1].extraWide ? 'small-letter-section-extrawide' : 'small-letter-section'">
              <p
                v-if="combo[1].title"
                class="small-letter-font small-letter-font--bold mb-2"
              >
                {{ combo[1].title }}
              </p>
              <p
                v-if="combo[1].intro"
                class="small-letter-font small-letter-font--bold mb-0"
              >
                {{ combo[1].intro }}
              </p>
              <ul class="small-letter-font justify-text spaced-list">
                <li
                  v-for="(elementList, listIndex) in combo[1].list"
                  :key="'textList-' + listIndex"
                  v-html="elementList"
                />
              </ul>
              <p
                v-if="combo[1].outro"
                class="small-letter-font justify-text mt-6 mb-0"
                v-html="combo[1].outro"
              />
            </div>
          </div>

          <!-- Handle text as combo[0] (split layout - text on its own page) -->
          <div
            v-if="combo[0] && combo[0].type === 'text'"
            class="d-flex justify-center mt-5"
          >
            <div :class="combo[0].extraWide ? 'small-letter-section-extrawide' : 'small-letter-section'">
              <p
                v-if="combo[0].title"
                class="small-letter-font small-letter-font--bold mb-2"
              >
                {{ combo[0].title }}
              </p>
              <p
                v-if="combo[0].intro"
                class="small-letter-font small-letter-font--bold mb-0"
              >
                {{ combo[0].intro }}
              </p>
              <ul class="small-letter-font justify-text spaced-list">
                <li
                  v-for="(elementList, listIndex) in combo[0].list"
                  :key="'textList-' + listIndex"
                  v-html="elementList"
                />
              </ul>
              <p
                v-if="combo[0].outro"
                class="small-letter-font justify-text mt-6 mb-0"
                v-html="combo[0].outro"
              />
            </div>
          </div>
        </div>
      </div>
      
      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus/Footer'

export default {
  name: 'CargaTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        // CTT Carga
        {
          type: 'table',
          ids: ['CCAR'],
          tableType: 'carga',
          imageUrl: require('@/assets/carga-icon.png'),
        },
        {
          type: 'text',
          title: 'Características do serviço Carga:',
          relatedTableType: 'carga',
          extraWide: true,
          list: [
            '• <b>Oferta:</b> B2B; <b>Produto:</b> Carga (D+1); <b>Fluxo:</b> PT Continente > PT Continente.',
            '• <b>Pesos máximos:</b> Volume: 30 kg; Palete: 1000 kg; Remessa: 5000 kg.',
            '• <b>Unidades por remessa máximos:</b> Volume: 999 unidades; Palete: 10 unidades.',
            '• <b>Dimensões Máximas:</b> Volume: 120 x 60 x 60 cm; Palete: 120 x 120 x 180 cm.',
            '• <b>Dimensões Máximas não cintável:</b> Volume: 200 x 120 x 80 cm.',
            '• <b>Dimensões Mínimas:</b> Volume: 15 x 11x 3,5 cm.',
            '• <b>Cubicagem:</b> Conversão volumétrica de 250 kg/m3 (meio de transporte terrestre).',
            '• <b>Serviços Adicionais Carga:</b> Cobrança, DDA.',
            'Existem destinos em que o prazo de entrega é de 2 dias úteis.'
          ]
        },
      ],
      previousPages: 0,
      measuredCombos: [],
      heightThreshold: 650, // Max height in px before moving text to next page
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST, GET_PRODUCT]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },

    combinedElements() {
      const combos = []
      const { elements } = this
      let i = 0

      while (i < elements.length) {
        const current = elements[i]

        if (current.type === 'table') {
          const selectedIds = current.ids.filter(id => this.isProductSelected(id))
          if (!selectedIds.length) {
            i++
            continue
          }

          const tableCopy = { ...current, ids: selectedIds }

          const nextEl = elements[i + 1]
          if (
            nextEl &&
            nextEl.type === 'text' &&
            nextEl.relatedTableType === tableCopy.tableType
          ) {
            // Initially combine them - we'll split later based on measured height
            combos.push([tableCopy, nextEl])
            i += 2
          } else {
            combos.push([tableCopy])
            i++
          }
        }
        else {
          i++
        }
      }
      return combos
    },

    pageGroupedElements() {
      const combos = this.measuredCombos.length > 0 ? this.measuredCombos : this.combinedElements
      if (!combos.length) return []
      return combos.map(combo => [combo])
    },
  },
  methods: {
    isProductSelected(tableId) {
      const product = this[GET_PRODUCT](tableId)
      return product && product.isPreSelected === true
    },
    getProduct(productId) {
      return this[GET_PRODUCT](productId)
    },
    
    async measureAndSplitCombos() {
      // Wait for DOM to be ready
      await this.$nextTick()
      
      if (this.measuredCombos.length > 0) return // Already measured
      
      const initialCombos = this.combinedElements
      if (initialCombos.length === 0) return
      
      const finalCombos = []
      
      // Iterate through initial combos to measure and decide splitting
      for (let comboIndex = 0; comboIndex < initialCombos.length; comboIndex++) {
        const combo = initialCombos[comboIndex]
        
        // If combo has both table and text, measure the table height
        if (combo.length === 2 && combo[0].type === 'table' && combo[1].type === 'text') {
          // Find the table element in DOM - it should be in page 0 since we haven't split yet
          const tableRefs = this.$refs[`table-0-${comboIndex}`]
          
          let shouldSplit = false
          if (tableRefs && tableRefs.length > 0) {
            const tableElement = tableRefs[0].$el
            const tableHeight = tableElement.offsetHeight
            shouldSplit = tableHeight > this.heightThreshold
            
            console.log(`Table height: ${tableHeight}px, threshold: ${this.heightThreshold}px, should split: ${shouldSplit}`)
          }
          
          if (shouldSplit) {
            finalCombos.push([combo[0]]) // Table on its own page
            finalCombos.push([combo[1]]) // Text on next page immediately after
          } else {
            finalCombos.push(combo) // Keep together
          }
        } else {
          finalCombos.push(combo) // Single elements stay as is
        }
      }
      
      // Update measured combos
      this.measuredCombos = finalCombos
      
      // Force re-render and update page count
      await this.$nextTick()
      this.$emit('updateTotalPages', { CargaTables: this.pageGroupedElements.length })
    },
  },
  created() {
    this.$emit('updateTotalPages', { CargaTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('CargaTables')
    // Trigger height measurement after DOM is ready
    this.measureAndSplitCombos()
  },
}
</script>
